<template>
  <div class="powerTc" >
    <div class="title">
      <span style="float: left;padding-left: 35px;padding-top: 10px">
        监测点列表
      </span>
      <span>
        <i class="el-icon-error" style="padding-right:21px;padding-top:15px;float: right;cursor:pointer;" @click="closeTc"></i>
      </span>
    </div>

    <div class="list-table">
      <el-table :data="Risktable"  align="center">
        <el-table-column prop="deptName" align="center"  label= "单位名称"></el-table-column>
        <el-table-column prop="siteName" align="center"  label= "监测点名称"></el-table-column>
        <el-table-column
          prop="timeout"
          label="操作"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="todetail(scope.row)"
              type="text"
              size="small"
            >
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="float: right;margin-right: 10px; margin-top: 10px;width: 90%;">
      <el-pagination
        @current-change="pageChange"
        background
        :current-page="page"
        :page-size="pageSize"
        layout="prev, pager, next"
        :total="pageall">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Bus from "@/utils/bus.js";
import Axios from "@/utils/Axios";
import Vue from "vue";
import {factors} from "@turf/turf";
import qs from "qs";
export default {
  name: "leftPage",
  props: {
    depid: {
      type: Number,
      default() {
        return '';
      }
    },
    alertLevel: {
      type: Number,
      default() {
        return '';
      }
    },
  },
  data() {
    return {
      showTc:false,
      Risktable:[],
      page: 1,
      pageall: 10,
      pageSize: 10,
    };
  },
  methods: {
    todetail(data){

      this.$router.push({
        name: "stationListPage",
        params: {
          val: [
            data.siteName,
            data.branchId,
            data.id,
            "/stationDetail",
          ],
        },
      });
      Bus.$emit("changeheader", "2");    },
    getRiskList(page){

      let param = {};
      param.method = "post";
      param.url = "/portal/realtimeRiskMonitorSitePage";
      param.data = {
        pageNum:page,
        showNum:this.pageSize,
        deptId:this.depid,
        alertLevel:this.alertLevel,
      };
      Axios.ajax(param).then((res) => {
        if (res.data) {
          this.Risktable=res.data.dataList
          this.pageall=res.data.totalNum
        }
      });
    },
    // 当前页数
    pageChange(val) {
      this.page = val;
      this.getRiskList(val);
    },
    closeTc(){
      Bus.$emit('colsetc',false )
    },

  },
  mounted() {
    this.depid= Number(localStorage.getItem("deptId"));
    this.getRiskList(1)


  },
  watch:{
    alertLevel(){
      this.getRiskList(1)
    }
  },
  components: {

  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.powerTc{
  width: 100%;
  height: 100%;
  background-color: #0C213F;
  position: absolute;
  right: 20px;
}
.list-table{
  margin: 14px 20px;
  height: 362px;
  overflow: auto;
}
//.left{
//  width: 428px;
//  height: 419px;
//  border: 1px solid #0B47A5;
//  //position: relative;
//  //left:72px;
//  //top: 270px;
//}
.title{
  height: 45px;
  width: 100%;
  background-color: rgba(61, 130, 234, 0.4);
  font-size: 16px;
  font-family: PingFang;
  color: #6CBCFD;
  line-height: 24px;
  letter-spacing: 2px;
}
.use-sum{
  width: 268px;
  height: 45px;
  font-size: 14px;
  font-family: PingFang;
  color: rgba(255, 169, 64, 0.8);
  line-height: 20px;
  letter-spacing: 2px;
  padding-top: 14px;
  padding-left:34px;
  position: relative;
  top:22px;
}
.text-style{
  font-size: 14px;
  font-family: PingFang;
  color: rgba(108, 188, 253, 0.8);
  line-height: 20px;
  letter-spacing: 2px;
  position: absolute;
  top:152px;
  left:34px;
}
.rectangle{
  display: inline-block;
}
.square{
  display: inline-block;
  width: 14px;
  height: 14px;
  background: rgba(11, 71, 165, 0.5);
  border: 1px solid #0B47A5;
}
.text1{
  padding-left:14px;
  display: inline-block;
  font-size: 12px;
  font-family: PingFang;
  color: #6CBCFD;
  line-height: 17px;
  letter-spacing: 1px;
}
.text2{
  position: absolute;
  left:268px;
  display: inline-block;
  font-size: 16px;
  font-family: Alternate;
  font-weight: bold;
  color: #6CBCFD;
  line-height: 19px;
  letter-spacing: 2px;
}
.text3{
  position: absolute;
  left:360px;
  display: inline-block;
  font-size: 16px;
  font-family: Alternate;
  color: #6CBCFD;
  line-height: 19px;
  letter-spacing: 2px;
}
.warm-type{
  display: inline-block;
  vertical-align: top;
  width: 370px;
  height: 160px;
  margin-left: 23px;
}
.warm-list{
  display: inline-block;
  vertical-align: top;
  width: 150px;
  height: 160px;
  margin-left: 23px;
}
.btn-list{
  float: right;
  margin-right: 37px;
  color: #6CBCFD;
  font-size: 14px;
  text-align: center;
  .btn-item{
    width: 36px;
    text-align: center;
    margin-left: 10px;
    cursor: pointer;
    display: inline-block;
  }
  .disnone{
    display: none;
  }
  .blue-blank{

    width: 36px;
    height: 3px;
    background-color: #6CBCFD;
    position: relative;
    top: 2px;

  }
}
.btn-left-list{

  color: #6CBCFD;
  font-size: 14px;
  width: 100px;
  display: inline-block;
  .btn-item{
    width: 36px;
    text-align: center;
    margin-left: 10px;
    cursor: pointer;
    display: inline-block;
  }
  .disnone{
    display: none;
  }
  .blue-blank{

    width: 36px;
    height: 3px;
    background-color: #6CBCFD;
    position: relative;
    top: 2px;

  }
}
.time-blank{
  float: right;
}
</style>
<style>
#app .login-wrap .time-blank .el-date-editor.el-input__inner, #app .time-blank .el-date-editor > .el-input__inner{
  background-color: #0C213F;
  color: #6CBCFD;
  border: 1px solid #0B47A5;
}
#app .time-blank .el-input__prefix, .el-input__suffix{
  color: #6CBCFD;

}
</style>

